import { render, staticRenderFns } from "./ProfilesLabelTable.vue?vue&type=template&id=eef007d6&scoped=true"
import script from "./ProfilesLabelTable.vue?vue&type=script&lang=js"
export * from "./ProfilesLabelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef007d6",
  null
  
)

export default component.exports